
const staffingApproach = [
  {
    title: 'Process Approach',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Staff%20Augementation/process_approach.jpg',
    imageAlt: 'Technology professional planning software delivery at a computer',
    points: ['Define the work', 'Match the skills', 'Review progress'],
  },
  {
    title: 'Solution Design',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Staff%20Augementation/solution_design.jpg',
    imageAlt: 'Technology consultants discussing a solution design',
    points: ['Explore use cases', 'Validate the approach', 'Plan delivery'],
  },
  {
    title: 'People Model',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Staff%20Augementation/people_model.jpg',
    imageAlt: 'Professionals collaborating in a planning workshop',
    points: ['Specialist talent', 'Team integration', 'Clear ownership'],
  },
  {
    title: 'Engagement Models',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Staff%20Augementation/engagement_models.jpg',
    imageAlt: 'Team discussing project delivery options',
    points: ['Flexible staffing', 'Dedicated teams', 'Managed services'],
  },
];

export default function StaffingApproach() {
  return (<section className="bg-white px-5 py-16 sm:px-6 lg:px-10 lg:py-24" aria-labelledby="staffing-approach-title">
      <div className="mx-auto max-w-[1360px]">
        <h2 id="staffing-approach-title" className="text-center text-[32px] font-semibold leading-[48px]" style={{ color: '#183762', marginBottom: 0 }}>Our Approach &amp; Methodology</h2>
        <p className="mx-auto mt-5 max-w-3xl text-center text-base font-normal leading-[27px]" style={{ color: '#212121' }}>A practical path from understanding your needs to building a team that delivers.</p>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {staffingApproach.map((item) => <article key={item.title} className="group relative h-[360px] overflow-hidden rounded-lg">
            <img src={item.image} alt={item.imageAlt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <div className="absolute inset-x-0 bottom-0 bg-[#102D57]/90 p-5 sm:p-6">
              <h3 className="text-xl font-semibold leading-tight text-white" style={{ marginBottom: 0 }}>{item.title}</h3>
              <ul className="mt-4 space-y-1.5">
                {item.points.map((point) => <li key={point} className="flex items-center gap-2 text-sm text-white/90 sm:text-base"><span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#86B4CC]" aria-hidden="true" />{point}</li>)}
              </ul>
            </div>
          </article>)}
        </div>
      </div>
    </section>);
}
